/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./squad.vue?vue&type=template&id=312fb945&scoped=true"
import script from "./squad.vue?vue&type=script&lang=js"
export * from "./squad.vue?vue&type=script&lang=js"
import style0 from "./squad.vue?vue&type=style&index=0&id=312fb945&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312fb945",
  null
  
)

export default component.exports